import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import _filter from 'lodash/filter';
import _every from 'lodash/every';
import _includes from 'lodash/includes';
import DateRange, { getPresetList } from '../../../molecules/dateRange';
import { getDefaulPresetFromFilter } from '../helpers/filterSection.filterType';
import filterTypeReader from '../readers/FilterType';
import s from '../organisms/defaultFilterToolbar/filtersList/filter.module.scss';
export var getSelectedFilterValues = function getSelectedFilterValues(selectedFilters, filterId) {
  var filterValue = _find(selectedFilters, {
    type: filterId
  });
  if (!filterValue) return undefined;
  return filterValue.values;
};
export var getDatePicker = function getDatePicker(filterType, values, additional) {
  var defaultPreset = getDefaulPresetFromFilter(filterType);
  var options = filterTypeReader.additional(filterType);
  var baseProps = _objectSpread({
    defaultValue: getPresetList()[defaultPreset],
    defaultPreset: defaultPreset,
    values: values,
    className: s.dateRangePicker,
    additional: additional
  }, options);
  return {
    component: DateRange,
    baseProps: baseProps
  };
};
export var getNonEmptyFilters = function getNonEmptyFilters(filters) {
  var skipFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return _filter(filters, function (_ref) {
    var values = _ref.values,
      type = _ref.type;
    return !_includes(skipFilters, type) ? !_isEmpty(values) : true;
  });
};
export var getFiltersWithOutNullValue = function getFiltersWithOutNullValue(filters) {
  return _filter(filters, function (_ref2) {
    var values = _ref2.values;
    return !_isEmpty(values) && !isNull(values);
  });
};
export var isNull = function isNull(values) {
  return _every(values, function (value) {
    return value == null;
  });
};